import React from 'react';
import {
    ComponentsProps,
    ComponentsOverrides,
    ComponentsVariants,
    Theme,
    SelectProps,
    outlinedInputClasses,
    selectClasses,
} from '@mui/material';
import { DownIcon } from '../../components';
import { StyleProps } from './utils/dynamicStyle';

function readOnlyIconStyle(props: StyleProps<SelectProps>) {
    if (props.ownerState?.readOnly) {
        return {
            color: props.theme.palette.action.disabled,
        };
    }
    return {};
}

export const MuiSelect: {
    defaultProps?: ComponentsProps['MuiSelect'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiSelect'];
    variants?: ComponentsVariants['MuiSelect'];
} = {
    defaultProps: {
        IconComponent: (args) => <DownIcon {...args} fontSize="large" />,
        displayEmpty: true,
        notched: false,
    },
    styleOverrides: {
        icon: (props) => [
            {
                color: 'inherit',
            },
            readOnlyIconStyle(props),
        ],
        select: (props) => ({
            [`.${outlinedInputClasses.root} &.${selectClasses.select}`]: {
                paddingInlineEnd: props.theme.spacing(props.theme.tokens.spacing.xxxl),
            },
        }),
    },
};
